export enum CrmFormEntity {
  Lead = 'Lead',
  Newsletter = 'Newsletter',
  Nps = 'NPS',
  ProductAcquisition = 'ProductAcquisition',
}
